module.exports = __webpack_public_path__ + "static/media/icon-market.b9580079.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon-market.svg
// module id = 392
// module chunks = 0